export default __webpack_public_path__ + "static/email-templates-adding-fields-6a213a9da5e9d238949341810b8eaccc.mp4";